import type {Iri} from '../../@types/Api'
import type {CollectionMap} from '../../@types/hydra/HydraCollection'
import type {HydraCollectionMember} from '../../@types/hydra/HydraCollectionMember'

interface ItemWithId {
  readonly '@id': Iri
}

export function mapItems<T extends ItemWithId>(items: T[] | undefined): Map<Iri, T> {
  return new Map(items?.map((item) => [item['@id'], item]))
}

export function mapFilter<T extends HydraCollectionMember>(map: CollectionMap<T>, callback: (item: T, key: Iri) => boolean): CollectionMap<T> {
  const collectionMap: CollectionMap<T> = new Map()
  for (const [key, item] of map) {
    if (callback(item, key)) {
      collectionMap.set(key, item)
    }
  }

  return collectionMap
}
